// eslint-disable-next-line @tseslint/typedef, @tseslint/no-unnecessary-type-assertion
export const CUSTOMER_ROLE_RESOURCE = "customer" as const;
// eslint-disable-next-line @tseslint/typedef
export const CUSTOMER_ROLES = {
  overview: "customer_overview",
  admin: "customer_admin",
  edit: "customer_edit",
  create: "customer_create",
  view: "customer_view",
  "delete": "customer_delete"
} as const;
export type CustomerRole = typeof CUSTOMER_ROLES[keyof typeof CUSTOMER_ROLES];

const allCustomerRoles: string[] = Object.values(CUSTOMER_ROLES) as string[];

export function isCustomerRole (role: string): role is CustomerRole {
  return allCustomerRoles.includes(role);
}
